import React, { useState, useEffect } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';

interface JavaScriptError {
  message: string;
  source: string;
  lineno: number;
  colno: number;
  error: string;
}

const DiagnosticPage: React.FC = () => {
  const { user } = useAuthenticator((context) => [context.user]);
  const [userAgent] = useState<string>(navigator.userAgent);
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState<number>(window.innerHeight);
  const [browserZoomLevel, setBrowserZoomLevel] = useState<number>(Math.round(window.devicePixelRatio * 100));
  const [jsErrors, setJsErrors] = useState<JavaScriptError[]>([]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
      setBrowserZoomLevel(Math.round(window.devicePixelRatio * 100));
    };

    window.addEventListener('resize', handleResize);

    window.onerror = (message, source, lineno, colno, error) => {
      const newError: JavaScriptError = {
        message: message.toString(),
        source: source || '',
        lineno: lineno || -1,
        colno: colno || -1,
        error: error?.toString() || '',
      };

      setJsErrors((currentJsErrors) => [...currentJsErrors, newError]);
    };

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div>
      <h1>Diagnostic Information</h1>
      <p>
        <strong>User Id:</strong> {user.userId}
      </p>
      <p>
        <strong>Env:</strong> {import.meta.env.MODE}
      </p>
      <p>
        <strong>Build:</strong> {import.meta.env.COMMIT_HASH}
      </p>
      <p>
        <strong>User Agent:</strong> {userAgent}
      </p>
      <p>
        <strong>Screen Width:</strong> {screenWidth}px
      </p>
      <p>
        <strong>Screen Height:</strong> {screenHeight}px
      </p>
      <p>
        <strong>Browser Zoom Level:</strong> {browserZoomLevel}%
      </p>
      <h2>JavaScript Errors</h2>
      {jsErrors.length > 0 ? (
        <ul>
          {jsErrors.map((error, index) => (
            <li key={index}>
              <p>
                <strong>Message:</strong> {error.message}
              </p>
              <p>
                <strong>Source:</strong> {error.source}
              </p>
              <p>
                <strong>Line:</strong> {error.lineno}, <strong>Column:</strong> {error.colno}
              </p>
              <p>
                <strong>Error:</strong> {error.error}
              </p>
            </li>
          ))}
        </ul>
      ) : (
        <p>No JavaScript errors detected.</p>
      )}
    </div>
  );
};

export default DiagnosticPage;
